export const HOMEPAGE_OPENINGS = [
    'ask-first',
    'content-first',
];
export const isHomepageOpening = (value) => typeof value === 'string' &&
    HOMEPAGE_OPENINGS.includes(value);
/** Subtitle a greeting hero starts with, shared by the starter homepage and
 * the opt-in swap of stored ask heroes to greetings. */
export const HOMEPAGE_DEFAULT_GREETING_SUBTITLE = 'Pick up where you left off, or start something new.';
//# sourceMappingURL=orgSettings.js.map